import { useQuery } from '@tanstack/react-query';
import { accessMemberQueryKey } from '../../consts/accessMemberQueryKey';
import { fetchAccessMember } from '../../helpers/fetchAccessMember';

const useGetAccessMember = () => {
  const {
    data,
    isLoading: loading,
    error,
  } = useQuery({
    queryKey: accessMemberQueryKey,
    queryFn: fetchAccessMember,
  });

  return {
    permittedSections: data?.permittedSections,
    accessMember: data?.accessMember,
    loading,
    error,
  };
};

export default useGetAccessMember;
